// extracted by mini-css-extract-plugin
module.exports = {"root":"UpdateFile_root__TEtxZ"};